// Shared styles for the contact sheet and its instrument panel.

// A checkbox drawn for the dark theme (the browser default ignores it): an
// outlined box that fills with `color` and a tick when checked.
export const checkboxSx = (color = '#2dd4bf') => ({
  appearance: 'none', WebkitAppearance: 'none', m: 0, width: '16px', height: '16px', flexShrink: 0, cursor: 'pointer', borderRadius: '4px',
  border: '1px solid rgba(120,150,200,.45)', backgroundColor: '#0b1730', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: '10px 8px',
  transition: 'background-color .12s, border-color .12s',
  '&:hover': { borderColor: color },
  '&:checked': { backgroundColor: color, borderColor: color,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 8'%3E%3Cpath d='M1 4l3 3 5-6' fill='none' stroke='%2304211d' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")` },
  '&:focus-visible': { outline: `2px solid ${color}`, outlineOffset: '2px' },
  '&:disabled': { opacity: 0.4, cursor: 'default' },
});
